export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const USER_PROFILE_LOADING = 'USER_PROFILE_LOADING';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';
export const UPDATE_PROFILE_FIRST_ADDRESS = 'UPDATE_PROFILE_FIRST_ADDRESS';
export const OPEN_MODAL_UPDATE_PERSONAL_DATA =
  'OPEN_MODAL_UPDATE_PERSONAL_DATA';
export const CLOSE_MODAL_UPDATE_PERSONAL_DATA =
  'CLOSE_MODAL_UPDATE_PERSONAL_DATA';
